"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = ['[_nghost-%COMP%]{height:100%;width:100%;font-size:12px;display:block}[_nghost-%COMP%]   span.required[_ngcontent-%COMP%]{color:red}'];
